export const YouTubeVideo = ({ alt, id }) => {

    // const [ videoDetails, setVideoDetails ] = useState({})

    // unreliable
    // useEffect(() => {
    //     const getInfoUrl = 'https://noembed.com/embed?url=https%3A%2F%2Fwww.youtube.com%2Fwatch%3Fv%3D'
    //     const infoForVideoUrl = getInfoUrl + id;
    
    //     axios.get(infoForVideoUrl)
    //         .then(res => {
    //             if (res.data) {
    //                 setVideoDetails(res.data)
    //             }
    //         })

    // }, [id])

    return (
        <div className="youtube-video">
            <iframe 
                src={`https://www.youtube.com/embed/${id}?rel=0`}
                frameBorder="0"
                title="YouTube Video"
                allow="accelerometer; encrypted-media; picture-in-picture; fullscreen;" 
                aria-describedby={`description-${id}`}
            />
            <div className="sr-only" id={`description-${id}`}>
                {alt}
            </div>
        </div>
    )
}